import { c as _c } from "react/compiler-runtime";
import type { SavedAddress } from '@newfront-insurance/address-api';
import { Padding, colors, Text, Flexbox, IconBookmark } from '@newfront-insurance/core-ui';
import * as React from 'react';
import type { JSX } from 'react';
import styled from 'styled-components';
import { HighlightQueryInText } from '../highlight-query-in-text';
interface Props {
  address: SavedAddress;
  handleSelectedResult: (address: SavedAddress) => unknown;
  onKeyDown: (event: React.KeyboardEvent<Element>) => void;
  addressQuery?: string;
}
export function SuggestedAddress(t0) {
  const $ = _c(32);
  const {
    onKeyDown,
    address,
    handleSelectedResult,
    addressQuery
  } = t0;
  const {
    addressLine1,
    addressLine2,
    city,
    displayName,
    stateOrArea,
    countryCode,
    postalCode
  } = address;
  let t1;
  if ($[0] !== address || $[1] !== handleSelectedResult) {
    t1 = () => handleSelectedResult(address);
    $[0] = address;
    $[1] = handleSelectedResult;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== address || $[4] !== handleSelectedResult || $[5] !== onKeyDown) {
    t2 = e => {
      if (e.key === "Enter") {
        handleSelectedResult(address);
        return;
      }
      onKeyDown(e);
    };
    $[3] = address;
    $[4] = handleSelectedResult;
    $[5] = onKeyDown;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      lineHeight: 1
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Padding right={12}><IconBookmark size={14} color="#98A6B5" /></Padding>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== addressQuery || $[10] !== displayName) {
    t5 = displayName && <Padding bottom={4}><Text color="inherit" size="regular" style={{
        lineHeight: "1"
      }}><HighlightQueryInText text={displayName} query={addressQuery} /></Text></Padding>;
    $[9] = addressQuery;
    $[10] = displayName;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== addressLine1 || $[13] !== addressQuery) {
    t6 = <HighlightQueryInText text={addressLine1} query={addressQuery} />;
    $[12] = addressLine1;
    $[13] = addressQuery;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== addressLine2 || $[16] !== addressQuery) {
    t7 = addressLine2 && <HighlightQueryInText text={addressLine2} query={addressQuery} />;
    $[15] = addressLine2;
    $[16] = addressQuery;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <Padding bottom={4}>{t6}{t7}</Padding>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = `${city}, ${stateOrArea}, ${postalCode}, ${countryCode}`;
  let t10;
  if ($[21] !== addressQuery || $[22] !== t9) {
    t10 = <div><HighlightQueryInText text={t9} query={addressQuery} /></div>;
    $[21] = addressQuery;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t5 || $[26] !== t8) {
    t11 = <Text size="small" color="inherit" style={t3}><Padding y={8} x={16}><Flexbox>{t4}<div>{t5}{t8}{t10}</div></Flexbox></Padding></Text>;
    $[24] = t10;
    $[25] = t5;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t1 || $[29] !== t11 || $[30] !== t2) {
    t12 = <StyledResult tabIndex={0} onClick={t1} onKeyDown={t2} data-previously-saved-address={true}>{t11}</StyledResult>;
    $[28] = t1;
    $[29] = t11;
    $[30] = t2;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
}
const StyledResult = styled.div`
  line-height: 1;

  &:hover,
  &:focus {
    background-color: ${colors.brand[400]};
    cursor: pointer;
    color: #fff;
  }

  &:hover > span path,
  &:focus > span path {
    fill: #fff;
  }
`;